import { FruitCitrusIcon } from './FruitCitrusIcon';

/**
 * author: Michael Irigoyen
 * id 1F2DF3F1-F380-491D-BC09-B3262612DF23
 * name fruit-citrus
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fruit-citrus.svg
 * tags
 * - Food / Drink 
 * - Agriculture 
 */
export const FruitLimeIcon = FruitCitrusIcon;
export default FruitLimeIcon